import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AuszugPrintOptions, AuszugSettingsService } from './auszug-settings-service';

import { FormatConfigService } from '../../../../core/services/format-config.service';
import { AuszugInfoItem, AuszugTypeEnum, FormatEnum } from '../auszug-print-service';
import { EigentuemerPrintOptionsMeta } from '../../../../core/gb-api';
import { ErweiterungConfigResponse } from '../../../../core/base-api';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { CapAlertService } from '../../../../core/extension/exceptions/cap-alert.service';
import { FormsModule } from '@angular/forms';
import { CapFormColumnsDirective } from '../../../form-control/form-columns.directive';
import { CapFormControlComponent } from '../../../form-control/form-control.component';
import { MetaDisablerDirective } from '../../../directives/meta-disabler.directive';
import { MetaValidatorDirective } from '../../../directives/meta-validator.directive';
import { NgClass } from '@angular/common';
import { Subscription } from 'rxjs';
import ActiveErweiterungenEnum = ErweiterungConfigResponse.ActiveErweiterungenEnum;

@Component({
  selector: 'cap-eigentuemer-auszug-settings',
  templateUrl: './eigentuemer-auszug-settings.component.html',
  styleUrls: ['./auszug-settings.component.scss'],
  imports: [
    TranslatePipe,
    FormsModule,
    CapFormColumnsDirective,
    CapFormControlComponent,
    MetaDisablerDirective,
    MetaValidatorDirective,
    NgClass
  ]
})
export class EigentuemerAuszugSettingsComponent implements OnInit, OnDestroy {
  @Input()
  format: FormatEnum;
  @Input()
  title: string;
  @Input()
  auszugItem: AuszugInfoItem;
  @Input()
  showFormatSelection: boolean;
  @Input()
  ids: Array<string>;
  @Input()
  indexNumber: number;
  @Input()
  hasToZip: boolean;
  hasRequiredErweiterung = false;

  auszugType: AuszugTypeEnum = 'Eigentuemer';
  public options: EigentuemerPrintOptionsMeta;
  private subscription: Subscription = new Subscription();

  constructor(
    public activeModal: NgbActiveModal,
    private auszugSettingsService: AuszugSettingsService,
    private config: FormatConfigService,
    private translateService: TranslateService,
    private alerts: CapAlertService
  ) {
    keysToTranslate<string>([
      'AufbereitungsoptionenEigentuemerAuszug',
      'AdressenAufbereiten',
      'EinstellungenSpeichernBisZurNaechstenAbmeldung',
      'Einstellungen'
    ]);
  }

  ngOnInit(): void {
    this.subscription.add(
      this.config.printConfig$.subscribe((config) => {
        this.options = config?.getEigentuemerAuszugOptions();
      })
    );
    this.format = 'PDF';
    this.subscription.add(
      this.config.erweiterungsConfig$.subscribe((config) => {
        this.hasRequiredErweiterung = config?.activeErweiterungen.includes(ActiveErweiterungenEnum.GB_AUSZUG_MIT_MEHREREN_GRUNDSTUECKEN);
      })
    );
  }

  confirm() {
    if (!!this.ids && this.ids?.length > 20) {
      this.activeModal.close(true);
      return this.alerts.warning(this.translateService.instant('HinweismeldungAuszuege'));
    }
    const auszugPrintOption = <AuszugPrintOptions>{
      auszugType: this.auszugType,
      printOptions: this.options,
      format: this.format,
      item: this.auszugItem,
      ids: this.ids,
      hasToZip: this.hasToZip,
      indexNumber: this.indexNumber
    };
    this.auszugSettingsService.confirmPrintSelection(auszugPrintOption);
    this.activeModal.close(true);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
